// extracted by mini-css-extract-plugin
module.exports = {"option":"Ijgs3","name":"_6Q1Zm"};